import StyleStack from "../../../../../../Reuse/UI/StyleStack";
import { Divider, Stack, Typography } from "@mui/material";
import TurnRightRoundedIcon from "@mui/icons-material/TurnRightRounded";
import React, { useCallback } from "react";
import { DroneNestIcon, BatteryIcon } from "../../../../../../Reuse/Icon";
import Title from "./Title";
import { doorStatus, DroneIcon, droneTypes } from "../../../Context";
import OverflowTooltip from "../../../../../../Reuse/UI/OverflowTooltip";
import StyledButton from "../../../../../../Reuse/UI/StyledButton";
import { useActiveCampusContext } from "../../Constant";

const DoorDetail = (props) => {
  const {
    isShowDroneNest = true,
    drone_nest = {},
    showOnMap = () => undefined,
  } = props;
  const { updateDoor } = useActiveCampusContext();

  const { status, device_id, id } = drone_nest?.doors;

  const door_status = doorStatus.filter((el) => el.value === status);
  const NewDoor_status = doorStatus.filter((el) => el.value !== status);

  return (
    <StyleStack
      direction={"column"}
      gap={1}
      sx={{ width: "100%", paddingY: 1, paddingX: 1.5 }}
    >
      <Stack
        direction={"row"}
        justifyContent={"space-between"}
        alignItems={"center"}
        sx={{ width: "100%" }}
      >
        <Title title={device_id} status={door_status?.at(0).label} />
        {!!showOnMap ? (
          <Stack
            direction={"row"}
            alignItems={"center"}
            gap={1}
            onClick={(e) => showOnMap(e, drone_nest)}
            sx={{ cursor: "pointer" }}
          >
            <OverflowTooltip variant="h5">Show on Map</OverflowTooltip>
            <TurnRightRoundedIcon sx={{ fontSize: 16 }} />
          </Stack>
        ) : null}
      </Stack>
      {isShowDroneNest ? (
        <Stack
          direction={"row"}
          justifyContent={"space-between"}
          alignItems={"center"}
          sx={{ width: "100%" }}
          gap={1}
        >
          <Detail drone_nest={drone_nest} />
          <StyledButton
            variant="contained"
            color="primary"
            size="small"
            sx={{ height: 34, minHeight: 34 }}
            onClick={updateDoor(id, NewDoor_status?.at(0).value)}
          >
            {NewDoor_status?.at(0).label}
          </StyledButton>
        </Stack>
      ) : null}
    </StyleStack>
  );
};

export default React.memo(DoorDetail);

const Detail = React.memo((props) => {
  const { drone_nest } = props;

  return (
    <Stack
      direction={"row"}
      gap={1}
      alignItems={"center"}
      sx={{ width: 0, flexGrow: 1 }}
    >
      <Typography variant="subtitle1" sx={{ whiteSpace: "nowrap" }}>
        {drone_nest?.floor?.label || "Unknown Floor"}
      </Typography>
      <Divider orientation="vertical" flexItem sx={{ borderRadius: 0.25 }} />
      <DroneNestIcon titleAccess="Drone Nest Location" sx={{ fontSize: 18 }} />
      <Typography
        variant="subtitle1"
        sx={(theme) => ({
          ...theme.mixins.overflow,
          // width: 0,
          // flexGrow: 1
        })}
      >
        In nest{" "}
        <Typography component={"span"} sx={{ color: "#51555C" }}>
          {drone_nest?.name || ""}
          {!!drone_nest?.display_id ? " - " + drone_nest?.display_id : ""}
        </Typography>
      </Typography>
    </Stack>
  );
});
const Detail1 = React.memo(({ battery_level = 0, weapon = [] }) => {
  let remaining = 0;
  let total = 0;
  let droneType = {};

  try {
    if (!!weapon && Array.isArray(weapon)) {
      for (const element of weapon) {
        remaining += element.rounds_remaining;
        total += element.total_rounds;

        if (!droneType.icon) {
          const match = droneTypes.find((d) => d.value === element.type);
          if (match) droneType = match;
        }
      }
    }
  } catch (error) {
    console.info("weapon data:", weapon);
    console.info("Error processing weapon data:", error);
  }
  const batteryColor =
    battery_level >= 60
      ? "#00FF47"
      : battery_level >= 30
        ? "#FFD700"
        : "#FF4D4F";
  return (
    <Stack direction={"row"} gap={1} alignItems={"center"} sx={{ flexGrow: 0 }}>
      {total > 0 ? (
        <Typography variant="subtitle1">
          {remaining}/{total}
        </Typography>
      ) : (
        <Typography variant="subtitle1" sx={{ color: "#999" }}>
          No weapons
        </Typography>
      )}
      <DroneIcon icon={droneType?.icon} />
      <Typography variant="subtitle1">{droneType?.label}</Typography>
      <Divider
        orientation="vertical"
        flexItem
        sx={{ borderRadius: 0.25, marginY: 0.5 }}
      />
      <Typography variant="subtitle1">{battery_level || 0}%</Typography>
      <BatteryIcon titleAccess="Battery Level" sx={{ color: batteryColor }} />
    </Stack>
  );
});
